interface DefineAuthParams {
  headers: Headers;
  token: string;
  allowOrigin?: boolean;
}

type DefineAuthHeadersFn = ({
  headers,
  allowOrigin,
  token,
}: DefineAuthParams) => Headers;

export const defineAuthHeaders: DefineAuthHeadersFn = ({
  headers,
  allowOrigin = true,
  token,
}): Headers => {
  if (allowOrigin && !headers.get('X_USER_ID')) {
    headers.set('X_USER_ID', localStorage.getItem('empNumber') || '');
  }

  if (allowOrigin) {
    headers.set('Access-Control-Allow-Origin', '*');
  }

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return headers;
};
